import React from 'react';
import Eyebrow from './Eyebrow';

type SectionHeadingProps = {
  eyebrow?: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  align?: 'center' | 'start';
  as?: 'h1' | 'h2';
  id?: string;
};

const SectionHeading: React.FC<SectionHeadingProps> = ({
  eyebrow,
  title,
  subtitle,
  align = 'center',
  as: Heading = 'h2',
  id,
}) => (
  <div className={`ui-heading-block--${align}`}>
    {eyebrow ? <Eyebrow>{eyebrow}</Eyebrow> : null}
    <Heading id={id} className="ui-heading">
      {title}
    </Heading>
    {subtitle ? <p className="ui-subtitle">{subtitle}</p> : null}
  </div>
);

export default SectionHeading;
